import React from "react";
import Profile from "../../components/Biography/Profile";
import CarouselSkills from "../../components/Skills/CarouselSkills";

const Home = () => {
  return (
    <div style={{ paddingTop: "2em" }}>
      <Profile />
      <CarouselSkills />
    </div>
  );
};

export default Home;
